/**
 * Ingredient Supplier Card - JavaScript
 * Manejo de interactividad y estilos dinámicos
 */

function initializeIngredientCard() {
  const buttons = document.querySelectorAll('.ingredient-card__button');
  
  buttons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });
}

// Agregar efectos hover al botón
document.addEventListener('DOMContentLoaded', initializeIngredientCard);

// Soporte para cambios dinámicos en el editor de Shopify
document.addEventListener('shopify:section:load', initializeIngredientCard);
